<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="row" id="main-content">
  <div class="col-xl-5 col-sm-12">
    <div class="map-frame" #mapdiv>
      <div id="map"></div>
    </div>
  </div>
  <div class="col-xl-7 col-sm-12 h-100">
    <div class="row h-100">
      <div class="col-sm-12 summary">
        <table class='table table-striped' aria-labelledby="tableLabel">
          <thead>
            <tr>
              <th class="asset">Asset</th>
              <th class="date">Last Update</th>
              <th class="pos">Lat</th>
              <th class="pos">Lon</th>
              <th class="loc">Device Location</th>
              <th class="loc">Movement Location</th>
              <th class="exp">
                <button [hidden]="!postions" (click)="exportData()" title="Export Data" class="export-button" >
                  <img class="export-image" alt="Export Data" src="../../img/btnExport.png" />
                </button>
              </th>
            </tr>
          </thead>
          <tbody class="dummy">
            <tr>
              <td class="h-2" colspan="8"></td>
            </tr>
          </tbody>
          <tbody>
            @for (item of postions; track item) {
              <tr (click)="selectRow(item)" [ngClass]="item.id == selectedRow?.id ? 'selected' : ''">
                <td class="asset"><div class="">{{ item.asset }}</div></td>
                <td class="date"><div class="date">{{ item.updateDateTime | date:'dd/MM/yyyy HH:mm' }}</div></td>
                <td class="pos"><div class="pos">{{ item.latitude | number : '1.2-4' }}</div></td>
                <td class="pos"><div class="pos">{{ item.longitude | number : '1.2-4' }}</div></td>
                <td class="loc"><div class="loc" [ngClass]="item.yabbyLocation?.name?.toLowerCase() != item.movementLocation.toLowerCase() ? 'text-warning' : ''">{{ item.yabbyLocation?.name }}</div></td>
                <td class="loc"><div class="loc" [ngClass]="item.yabbyLocation?.name?.toLowerCase() != item.movementLocation.toLowerCase() ? 'text-warning' : ''">{{ item.movementLocation }}</div></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>